import { ObservableArray, View } from "binder"
import { SingleInvoice, LogisticCostCartableViewModel } from "./logisticCostCartable-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class LogisticCostCartableView extends View<LogisticCostCartableViewModel>{
    GetViewUniqueId(): string {
        return "V-2B9FA2F4-3777-4124-9B9D-5E49B0B816DF"
    }
    loadHtml(): string {
        let element = require('./logisticCostCartable.html').default;
        let style = require('./logisticCostCartable.less');
        return element;
    }
    constructor() {
       super();
    }

    public set invoicesLists(v: ObservableArray<SingleInvoice>) { this._invoicesLists = v; } public get invoicesLists(): ObservableArray<SingleInvoice> { return this._invoicesLists;} private _invoicesLists: ObservableArray<SingleInvoice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set rate(v: string) { this._rate = v; } public get rate(): string { return this._rate;} private _rate: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  


    setRate() {
        this.dataContext.setRate();
    }

}

